import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ENV from "libs/configs/env";
import queryString from "query-string";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { clearLoginAsyncState, login } from "redux/modules/authSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(./assets/images/bg-login.png), linear-gradient(to bottom left, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundBlendMode: "screen",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 17px 0 rgba(44, 40, 40, 0.11)",

    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 25,
    paddingButton: 45,
    flex: 1,
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  logo: {
    display: "flex",
    alignSelf: "center",
    width: 300,
    margin: theme.spacing(4),
  },
  title: {
    fontSize: 55,
    color: "#003b5c",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: 50,
    backgroundColor: "#11cdef",
    alignSelf: "center",
  },
  offlineLogin: {
    alignSelf: "center",
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  line: {
    marginTop: 8,
    height: 3,
    width: 50,
    backgroundColor: "#11cdef",
  },
}));

export default function Login() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { search } = useLocation();
  const queryParams = queryString.parse(search);

  const { isLoading, isSuccess, isFailure } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    dispatch(clearLoginAsyncState());
  }, [dispatch]);

  useEffect(() => {
    if (!!queryParams.code && !isLoading && !isFailure && !isSuccess) {
      console.log("queryParams ", queryParams);
      dispatch(login(queryParams.code, ENV.getConfig().loginRedirectUrl));
    }
  }, [
    dispatch,
    isFailure,
    isLoading,
    isSuccess,
    queryParams,
    queryParams.code,
  ]);

  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(clearLoginAsyncState());
      history.replace("/");
    }
  }, [isSuccess, isLoading, history, dispatch, isFailure]);

  const oneLoginURL = `${ENV.getConfig().oneUrl}/getcode?client_id=${
    ENV.getConfig().oneClientId
  }&response_type=code&redirect_uri=${ENV.getConfig().loginRedirectUrl}`;

  const handleClickOffline = () => {
    history.push("/login-offline");
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="sm">
        <Card className={classes.paper}>
          <CardContent className={classes.content}>
            <Typography variant="h4" className={classes.title}>
              Login
            </Typography>
            <Typography variant="h6">Smart VISA Service</Typography>
            <div className={classes.line} />
            <img
              alt="smart-visa"
              src="/assets/images/logo.png"
              className={classes.logo}
            />
            <Button
              variant="contained"
              color="secondary"
              size="large"
              className={classes.submit}
              disabled={isLoading}
              component="a"
              href={oneLoginURL}
            >
              {isLoading && (
                <CircularProgress
                  color="secondary"
                  className={classes.loading}
                  size={18}
                />
              )}
              Continue with OnePlatform
            </Button>
            <Button
              color="secondary"
              size="small"
              className={classes.offlineLogin}
              fullWidth={false}
              disabled={isLoading}
              onClick={handleClickOffline}
            >
              For Offline User
            </Button>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}
